<div (click)="blockClick($event)" class="min-h-screen relative">
<app-loader *ngIf="!loaded"></app-loader>
<app-error-page *ngIf="errorPage"></app-error-page>
<ng-template #dynamicComponentContainer></ng-template>
<div class="w-full flex items-center justify-center h-[7vh]">
    <img class="h-[3vh]" src="../../../assets/logo.svg">
</div>
</div>